import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { alertActions } from '_store';

export { Alert };

function Alert() {
    const dispatch = useDispatch();
    const location = useLocation();
    const alerts = useSelector(x => x.alert.list);

    useEffect(() => {
        // clear alert on location change
        dispatch(alertActions.clear());
    }, [location]);

    // clear alert after 2 seconds
    useEffect(() => {
        alerts.forEach(alert => {
            const timer = setTimeout(() => {
                dispatch(alertActions.remove(alert.id));
            }, 3000);
            return () => clearTimeout(timer);
        });
    }, [alerts]);

    if (!alerts.length) return null;

    return (
        <div className="alert-container">
            {alerts.map(alert => (
                <div key={alert.id} className={`alert alert-dismissible ${alert.type}`}>
                    {alert.message}
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => dispatch(alertActions.remove(alert.id))}
                    ></button>
                </div>
            ))}
        </div>
    );
}
